<div *ngIf="form" class="flex items-center gap-2 h-8" [formGroup]="form">
    <mat-label [class]="beforeLabelClass">{{ beforeLabel }}</mat-label>
    <mat-slide-toggle
            [formControlName]="controlName"
            color="primary"
    ></mat-slide-toggle>
    <mat-label>{{ afterLabel }}</mat-label>
</div>
